import * as React from 'react'
const HalfCurveBottom = (props) => (
  <svg
    width={389}
    height={61}
    viewBox="0 0 389 61"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g filter="url(#filter0_d_2442_87409)">
      <path
        d="M-446 661.5C-446 307.209 -158.791 20 195.5 20C549.791 20 837 307.209 837 661.5V877H-446V661.5Z"
        fill="white"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_2442_87409"
        x={-466}
        y={0}
        width={1323}
        height={897}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation={10} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_2442_87409"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_2442_87409"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
)
export default HalfCurveBottom
